module.exports = __webpack_public_path__ + "static/scale-model-of-hallidie-building-in-san-francisco-california-ae5a66de2b26d8ceb7e6351c4cd86e44.png";